module.exports = __webpack_public_path__ + "img/icon_bg8.4365fce1.png";